__turbopack_context__.v({
  "contact-content": "_9JNDXW_contact-content",
  "contact-info": "_9JNDXW_contact-info",
  "header-container": "_9JNDXW_header-container",
  "info": "_9JNDXW_info",
  "team": "_9JNDXW_team",
});
